import { render, staticRenderFns } from "./gzhNewsDetails.vue?vue&type=template&id=59d43f66&"
import script from "./gzhNewsDetails.vue?vue&type=script&lang=js&"
export * from "./gzhNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./gzhNewsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports